import { getCalendarProviderAccounts } from '../services/getCalendarProviderAccounts';
import type { CalendarProviderAccount } from '../store/schema/CalendarProviderAccount';
import { orchestrator } from 'satcheljs';
import {
    loadCalendarProviderAccounts,
    calendarProviderAccountsLoaded,
    errorInLoadingCalendarProviderAccounts,
} from '../actions/publicActions';
import { createCalendarProviderAccount } from '../utils/createCalendarProviderAccount';
import { getCalendarProviderAccounts as getProviderAccounts } from '../selectors/calendarProviderAccountsSelectors';

orchestrator(loadCalendarProviderAccounts, async () => {
    if (getProviderAccounts().length == 0) {
        const providerAccounts = await getCalendarProviderAccounts();

        if (providerAccounts?.calendarProviderAccounts) {
            const accounts = providerAccounts.calendarProviderAccounts.map<CalendarProviderAccount>(
                createCalendarProviderAccount
            );
            calendarProviderAccountsLoaded(accounts);
        } else {
            errorInLoadingCalendarProviderAccounts();
        }
    }
});
